module.exports = __webpack_public_path__ + "static/media/tunel_1.e62d5ddf.mp4";